import { render, staticRenderFns } from "./PushNotificationModal.vue?vue&type=template&id=84b8740e"
import script from "./PushNotificationModal.vue?vue&type=script&lang=js"
export * from "./PushNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports